(function () {
    'use strict';

    let paginatedCard = {};

    const paginationList = document.querySelector(
        ".qld__card--wrapper .qld__search-pagination__list"
    );

    const paginationAll = document.querySelector(
        ".qld__search-pagination .qld__search-pagination__list--all"
    );

    // Static HTML buttons
    const backBtnHTML = `
        <li class="prev">
            <a href="#" id="page-back" class="qld__search-pagination_link" aria-label="Previous page of results">
                <svg class="qld__icon qld__icon--sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="16" height="16" role="img"><path fill="currentColor" d="M448 256C448 264.8 440.6 272 431.4 272H54.11l140.7 149.3c6.157 6.531 5.655 16.66-1.118 22.59C190.5 446.6 186.5 448 182.5 448c-4.505 0-9.009-1.75-12.28-5.25l-165.9-176c-5.752-6.094-5.752-15.41 0-21.5l165.9-176c6.19-6.562 16.69-7 23.45-1.094c6.773 5.938 7.275 16.06 1.118 22.59L54.11 240h377.3C440.6 240 448 247.2 448 256z"></path></svg>
            </a>
        </li>`;
    const nextBtnHTML = `
        <li class="next">
            <a href="#" id="page-next" class="qld__search-pagination_link" aria-label="Next page of results">
                <svg class="qld__icon qld__icon--sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="16" height="16" role="img"><path fill="currentColor" d="M443.7 266.8l-165.9 176C274.5 446.3 269.1 448 265.5 448c-3.986 0-7.988-1.375-11.16-4.156c-6.773-5.938-7.275-16.06-1.118-22.59L393.9 272H16.59c-9.171 0-16.59-7.155-16.59-15.1S7.421 240 16.59 240h377.3l-140.7-149.3c-6.157-6.531-5.655-16.66 1.118-22.59c6.789-5.906 17.27-5.469 23.45 1.094l165.9 176C449.4 251.3 449.4 260.7 443.7 266.8z"></path></svg>
            </a>
        </li>`;


    let prevWidth = window.innerWidth;
    

    /**
     * Render pagination HTML
     * 
     * @param {boolean} isMobile
     * @param {number} total
     * @param {number} pageNumber
     */
    paginatedCard.renderPagination = function (isMobile, total, pageNumber, link) {
        paginationList.innerHTML = "";

        // build pagination
        const requiredPages = total;
        const maxPagesToShow = isMobile ? 4: 10;
        let startPage, endPage;

        if (requiredPages < 2) return;

        // calculate start and end pages based on current page
        if (requiredPages <= maxPagesToShow) {
            startPage = 1;
            endPage = requiredPages;
        } else {
            if (pageNumber <= (isMobile ? 3: 5)) {
                startPage = 1;
                endPage = maxPagesToShow;
            } else if (pageNumber + (isMobile ? 2 : 4) >= requiredPages) {
                startPage = requiredPages - maxPagesToShow + 1;
                endPage = requiredPages;
            } else {
                startPage = pageNumber - (isMobile ? 1 : 4);
                endPage = pageNumber + (isMobile ? 2 : 5);
            }
        }

        // create links
        paginationList.innerHTML += backBtnHTML;
        for (let index = startPage; index <= endPage; index++) {
            const pageLinkHTML = `
                <li class="num">
                    <a id="page-${index}" href="${link}${index}" class="qld__search-pagination_link num-link">${index}</a>
                </li>
            `;
            paginationList.innerHTML += pageLinkHTML;
        }
        paginationList.innerHTML += nextBtnHTML;

        // add functionality to next and back buttons
        const backBtn = document.getElementById("page-back");
        const nextBtn = document.getElementById("page-next");

        

        
        if (pageNumber === 1) {
            backBtn.parentElement.style.display = "none";
        } else {
            const prevPage = pageNumber - 1;
            backBtn.setAttribute('href', link + prevPage);
        }

        if (pageNumber == requiredPages) {
            nextBtn.parentElement.style.display = "none";
        } else {
            const nextPage = pageNumber + 1;
            nextBtn.setAttribute('href', link + nextPage);
        }

        // add active link class
        const activeLink = document.getElementById(`page-${pageNumber}`);
        activeLink.parentElement.classList.add("active");
    }

    /**
     * Window resize handler
     */
    paginatedCard.resizeHandler = function () {
        const curWidth = window.innerWidth;
        if (paginationList.hasChildNodes()) {
            const total = parseInt(paginationList.getAttribute('data-total'));
            const page = parseInt(paginationList.getAttribute('data-page'));
            const link = paginationList.getAttribute('data-url');

            if (prevWidth <= 700 && curWidth > 700){
                paginatedCard.renderPagination(false, total, page, link);
            } else if (prevWidth > 700 && curWidth <= 700) {
                paginatedCard.renderPagination(true, total, page, link);
            }
        }
        prevWidth = curWidth;
    }

    window.addEventListener("DOMContentLoaded", function () {
        if (paginationList){
            // check for mobile
            const isMobile = window.innerWidth < 700 ? true : false;
            const total = parseInt(paginationList.getAttribute('data-total'));
            const page = parseInt(paginationList.getAttribute('data-page'));
            const link = paginationList.getAttribute('data-url');

            paginatedCard.renderPagination(isMobile, total, page, link);

            if (paginationAll) {
                paginationAll.remove();
            }
        }
    });

    if (paginationList){
        window.addEventListener('resize', QLD.utils.debounce(paginatedCard.resizeHandler, 250));
    }
}());
